import * as stylex from '@stylexjs/stylex'
import { shadow, typographyColor } from './tokens.stylex'

export const calloutTypographyColors = stylex.createTheme(typographyColor, {
  brandPrimaryHeading: '#f8fbff',
  brandSecondaryHeading: '#afcfff',
  brandLabel: '#86b6ff',
  neutralPrimaryHeading: '#ffffff',
  neutralSecondaryHeading: '#eef1f6',
  neutralDarkTint: 'hsla(0, 100%, 100%, 0.3)',
  neutralBase: '#c9cdda',
  criticalLabel: '#ff6464',
  successLabel: '#41b057',
  nakedInlineButtonBackground: 'hsla(0, 0%, 100%, 0.1)',
  action: '#c9cdda',
  actionBackground: 'hsla(0, 0%, 100%, 0.1)',
})

export const resetTypographyColors = stylex.createTheme(typographyColor, {})

export const calloutShadowColors = stylex.createTheme(shadow, {
  elevationNeutralOnLight30:
    '0 3px 3px rgba(0, 0, 0, 0.6), 0 5px 16px 0 rgba(0, 0, 0, 0.9)',
})
